import { Gateway } from '../gateway.model';
import operations from '~/helpers/device-operations';
import { FieldObject } from '~/interfaces/field.interface';
import { batteryAlarmState, lastSoundTest, sensorBatteryVoltage, soundTest, statusTempered } from '~/helpers/monkey-fields-description';
import { MonkeyFields, NCOFields, Operation } from '~/interfaces/device.interface';
import { batteryPercent, batteryVoltageMax, batteryVoltageMin, notificationWifiConnection, soundTestReminder } from '~/helpers/nsd-fields-description';
import { getServerNodeFields } from '~/models/helpers/network.function';

export class NCO extends Gateway {
    MAX_TIME_BEFORE_UNKNOWN = 31 * 24 * 3600;
    MAX_TIME_BEFORE_CONSIDERED_DISCONNECTED = 31 * 24 * 3600;
    hasOperationImportData = false;
    hasOperationMainloop = false;
    hasModulesCount = false;
    nexelec?: MonkeyFields;
    nco?: NCOFields;

    get deviceOperations(): Operation[] {
        return super.deviceOperations.concat([
            operations.orderReboot({ callback: this.orderReboot, disabled: this.isOrderRebootDisabled }),
        ]);
    }

    get nexelecFields(): FieldObject[] {
        if (!this.nexelec) {
            return [{ key: 'No Info', value: '' }];
        }
        return [
            sensorBatteryVoltage('Nexelec', this.nexelec.sensor_battery_voltage),
            batteryAlarmState(this.nexelec.battery_alarm_state),
            statusTempered(this.nexelec.status_tampered),
            soundTest(this.nexelec.sound_test),
            lastSoundTest(this.nexelec.last_sound_test),
        ];
    }

    get NCOFields(): FieldObject[] {
        if (!this.nco) {
            return [{ key: 'No Info', value: '' }];
        }
        return [
            batteryPercent(this.nco.battery_percent),
            batteryVoltageMax(this.nco.battery_voltage_max),
            batteryVoltageMin(this.nco.battery_voltage_min),
            soundTestReminder(this.nco.sound_test_reminder),
            notificationWifiConnection(this.nco.notify_wifi_connection),
        ];
    }

    getNetworkFields(): FieldObject[] {
        let fields: FieldObject[] = super.getNetworkFields();
        if (this.network) {
            fields = fields.concat(getServerNodeFields(this.network.server_node));
        }
        return fields;
    }

}
